export default "__VITE_ASSET__CdMOXXly__"